import { hasActivePlan } from './planAccess'
import { getDealChecklistBlockedRedirect, isDealChecklistHiddenForRole } from './dealChecklistAccess'
import {
  getBuyerOutreachBlockedRedirect,
  isBuyerOutreachHiddenForUser,
} from './brokerListingAccess'

const BUYER_OUTREACH_PATHS = ['/recommended-buyers']

function isBuyerNetworkComplete(parsedUser) {
  return Boolean(parsedUser?.buyerNetworkComplete ?? parsedUser?.buyer_network_complete)
}

function isEmailVerified(parsedUser) {
  return Boolean(parsedUser?.emailVerified ?? parsedUser?.email_verified)
}

/**
 * Returns a redirect path when the user must complete onboarding, payment, or
 * verification before accessing `currentPath`. Null means the path is allowed.
 */
export function getRedirectPathForUser(currentPath, parsedUser) {
  const allowWithoutRole = ['/onboarding-role']
  const allowWithoutPlan = ['/payment', '/onboarding-role']
  const allowWithoutBuyerNetwork = ['/buyer-onboarding', '/onboarding-role', '/listing', '/buyer-deal', '/deal-access']
  const userRole = parsedUser?.role || null
  const userPlan = parsedUser?.userPlan || parsedUser?.user_plan
  const planExpiryDate = parsedUser?.planExpiryDate || parsedUser?.plan_expiry_date
  const hasStripeCustomer = Boolean(
    parsedUser?.hasStripeCustomer ||
      parsedUser?.has_stripe_customer ||
      parsedUser?.stripeCustomerId ||
      parsedUser?.stripe_customer_id
  )
  if (!isEmailVerified(parsedUser)) {
    return '/signup?verify=pending'
  }

  if (!userRole && !allowWithoutRole.includes(currentPath)) {
    return '/onboarding-role'
  }

  if (
    userRole === 'buyer' &&
    !isBuyerNetworkComplete(parsedUser) &&
    !allowWithoutBuyerNetwork.includes(currentPath) &&
    !currentPath.startsWith('/listing') &&
    !currentPath.startsWith('/buyer-deal')
  ) {
    return '/buyer-onboarding'
  }

  if (
    (userRole === 'broker' || userRole === 'advisor') &&
    !hasActivePlan(userPlan, planExpiryDate, hasStripeCustomer) &&
    !allowWithoutPlan.includes(currentPath)
  ) {
    return '/payment'
  }

  if (currentPath === '/deal-checklist' && isDealChecklistHiddenForRole(userRole)) {
    return getDealChecklistBlockedRedirect(userRole)
  }

  if (BUYER_OUTREACH_PATHS.includes(currentPath) && isBuyerOutreachHiddenForUser(parsedUser)) {
    return getBuyerOutreachBlockedRedirect(userRole)
  }

  return null
}
